
import './App.css';
import {useState, useEffect} from 'react';
import Question from './components/Question';
import { nanoid }from 'nanoid'

function App() {
  const [isStarted, setStarted] = useState(false);
  const [data, setData] = useState(null);
  const [questionsState, setQuestionsState] = useState(null)
  const [count, setCount] = useState(0);
  const [gameOver, setGameOver] = useState(false)
  const [loadAgain, setloadAgain] = useState(false)
 
  const [optionState, setOptionState] = useState({category: null, 
                                                  difficulty: null,
                                                  categoryName : null, 
                                                  difficultyName: null })

  const handleClick = () =>{
    setStarted(true);
    setGameOver(false)
  }
  useEffect(() =>{
    const base = 'https://opentdb.com/api.php?amount=5'
    const cat = optionState.category === null? '' :`&category=${optionState.category}`
    const diff = optionState.difficulty === null? '' : `&difficulty=${optionState.difficulty}`
    const url = base + cat + diff

    console.log(url)
    fetch(url)
    .then(response => response.json())
    .then(data => {
      console.log(data)
      setData(data)
      // const arr = data.results.map(q => {
      //   return {
      //     question: q.question,
      //     answer: q.correct_answer,
      //     selected: null,
      //     id: nanoid()}
  
      //  }
      // )
      // setQuestionsState(arr)
      // console.log(questionsState)
    })
    .catch(error => console.log(error))
     
 
  }, [optionState, loadAgain])
  useEffect(()=>{
    if(data !== null){
      const arr = data.results.map(q => {
      return {
        question: q.question,
        correct_answer: q.correct_answer,
        selected: null,
        isAnswerCorrect: null,
        id: nanoid(),
        incorrect_answers: q.incorrect_answers
      }

     }
    )
    setQuestionsState(arr)
    // console.log(questionsState)
    }
  },[data])

  const selectedOption = (id, selected)=>{
    setQuestionsState(pervState => {
     return pervState.map(question => (
       question.id === id ? {...question, selected: selected, isAnswerCorrect: question.correct_answer === selected } : question
     ))
    })
    
  }
  const checkAnswers = ()=>{
      questionsState.map(question =>{(
        question.selected === question.correct_answer && setCount(count => count+1)
      )})
       setGameOver(true)
  }

  const playAgain = () =>{
    // setStarted(false)
    setloadAgain(!loadAgain)
    setGameOver(false)
    setCount(0)

   
  }
   const stylesSelected = { 

        border:"none",
        color: "#293264",
        backgroundColor:  "#D6DBF5" 
  }
  const arr =['mythology', 'general knowledge', 'sports', 'history']
  const diff = ['Easy', 'Medium', 'Hard']
  const selectCategory = (e) =>{
    if(e === 'general knowledge'){
      setOptionState(prevState => (
        {...prevState, category: 9, categoryName : 'general knowledge'}
      ))
    }
    else if(e === 'mythology'){
      setOptionState(prevState => (
        {...prevState, category: 20, categoryName : 'mythology'}
      ))
    }
    else if(e === 'sports'){
      setOptionState(prevState => (
        {...prevState, category: 21, categoryName : 'sports'}
      ))
    }
    else if(e === 'history'){
      setOptionState(prevState => (
        {...prevState, category: 23, categoryName : 'history'}
      ))
    }
   
  }
  const selectDifficulty = (e) =>{
    console.log(optionState)

    if(e === 'Easy') {
      setOptionState(prevState => (
      {...prevState, difficulty: 'easy', difficultyName: e}
    ))
    }
    if(e === 'Medium') { 
      setOptionState(prevState => (
        {...prevState, difficulty: 'medium', difficultyName: e}
      ))
    }
    if(e === 'Hard') {  
      setOptionState(prevState => (
      {...prevState, difficulty: 'hard', difficultyName: e}
    ))}
  }
  const goToMenu = () =>{
    setStarted(false)
    setOptionState(prevState => (
      {category: null, difficulty: null,categoryName : null }
    ))
  }
  return (
    <div className="App">
  

      {
        isStarted === false ? 
          <div className = "intro">
            <div className = 'intro-container'>
              <h1>Quizzical</h1>
              <h2>Select category</h2>
              <div className = ' category btn-category'>
                {arr.map(e => (<button style = { (optionState.categoryName === e ? stylesSelected : null)} className = 'btn-option'  onClick = {() => selectCategory(e) } >{e}</button>))}
              </div>
              <h2>Select difficulty</h2>
              <div className = 'category'>
                {diff.map(e => (<button style = {optionState.difficultyName === e ? stylesSelected : null} className = 'btn-option'  onClick = {() => selectDifficulty(e) } >{e}</button>))}
              </div>
              <button className='btn btn-start' onClick={handleClick}>Start Quiz</button>
            </div>
          </div>

          :
          <div className='q-container'>
          <div className = "questions-page">
            {
               
               questionsState &&  questionsState.map(q => <Question 
                                                     key = {q.id}
                                                     qdata = {q.question}
                                                     correct_answer = {q.correct_answer}
                                                     incorrect_answers = {q.incorrect_answers} 
                                                     selectedOption = {(id,selected)=>selectedOption(id,selected)}
                                                     setQuestionsState = {setQuestionsState}
                                                     selected = {q.selected}
                                                     isAnswerCorrect = {q.isAnswerCorrect}
                                                     id = {q.id}
                                                     gameOver = {gameOver}
                                                     />)
              
            }
            { gameOver ?
                         <div className='game-over'><p> You scored {count}/5 points</p> <button onClick = {playAgain} className = ' btn-play-again'>Play Again </button>
                         <button className ='btn-menu' onClick = {goToMenu}>Menu</button></div> 
                        :  <button onClick = {checkAnswers} className='btn-check'>Check Answers</button>}
   
          </div>
          </div>
       

      }
    </div>
  );
}

export default App;
